import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'
import { languageChange, upload, setLoadingVisible } from 'store/siteConfig'

export default function(route) {
  const Report = Loadable({
    loader: () => import('./Report'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          riskUnauthReportState: state.riskUnauthReportState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          languageChange,
          upload,
          submit,
          setLoadingVisible
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/report`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Report {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
